import { withNotificationBand } from "./notificationBand.js";
import { isPhoneLayoutNow } from "./phoneLayout.js";

const SHOW_PAGE = /^\/booking\/shows\/([^/?#]+)/;
const ON_THE_ROAD = new Set(["logistics_added", "flight_delay"]);

/**
 * Where a tapped core push goes (ART-259 C6). The server writes one `route` for every recipient; this is the one
 * place it is adjusted for the device the tap landed on. Today that is a single rule: logistics and flight pushes
 * point at the desktop booking page, and on a phone they open the show's mobile LOGISTICS screen instead — booking
 * editing is desktop-only (ART-153), and the travel the push is about lives on that screen.
 *
 * An org-only person's message push needs no rule here: the router sends `/messages/{id}` to their roster inbox,
 * which also covers a bell tap and a restored tab.
 */
export function translateCorePush(
  data: Record<string, unknown> | undefined,
  phoneWidth: () => boolean = isPhoneLayoutNow,
): string | null {
  const raw = data?.["route"];
  if (typeof raw !== "string") return null;
  let route = raw;
  const kind = data?.["kind"];
  if (typeof kind === "string" && ON_THE_ROAD.has(kind) && phoneWidth()) {
    const show = SHOW_PAGE.exec(route)?.[1];
    if (show) route = `/shows/${show}/logistics`;
  }
  // The band the notification belongs to rides the route to the deep-link navigator, which opens it in that band
  // (asking first if it would change the active band) and strips it — notificationBand.ts.
  const bandId = data?.["bandId"];
  return typeof bandId === "string" && bandId ? withNotificationBand(route, bandId) : route;
}
